import styles from "./Item.module.css";
// import SelectTime from "./../../../SelectCenter/Centers/SelectTime/SelectTime";

// icons
import { ReactComponent as EditIcon } from "./../../../../../assets/svg/edit.svg";
import { ReactComponent as TrashIcon } from "./../../../../../assets/svg/trash.svg";
import { Modal } from "antd";
import Button from "../../../../components/ui/Button";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const Item = (props) => {
  const {
    active,
    onClick,
    address,
    id,
    noCheckbox,
    onEdit,
    onDelete,
    city,
    company_name,
  } = props;
  const [loading, setLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div onClick={onClick} className={styles.Item} key={id}>
        <div className={styles.TitleEditContainer}>
          {!noCheckbox && (
            <div
              className={`${styles.CheckboxCircleContainer} ${
                active ? styles.Active : ""
              }`}
            >
              <div
                className={`${styles.CheckboxCircle} ${
                  active ? styles.Active : ""
                }`}
              />
            </div>
          )}
          {company_name !== "" ? <div>{company_name}</div> : null}
          <div>{address}</div>
          <div className={styles.city}>{city}</div>
        </div>
        <div className={styles.buttonsContainer}>
          <button className={styles.ctaButton} onClick={() => onEdit(id)}>
            <EditIcon width={16} height={16} />
          </button>
          <button
            className={styles.ctaButton}
            onClick={() => setDeleteModalOpen(true)}
          >
            <TrashIcon width={16} height={16} />
          </button>
        </div>
        <Modal
          className="address-delete-modal"
          centered={true}
          closable={false}
          open={deleteModalOpen}
          destroyOnClose
          title={t("address.delete_address")}
          okText={t("common.yes")}
          cancelText={t("common.no")}
          onCancel={() => setDeleteModalOpen(false)}
          onOk={() => {
            setLoading(true);
            onDelete(id)
              .then(() => {
                setDeleteModalOpen(false);
              })
              .finally(() => {
                setLoading(false);
              });
          }}
          okButtonProps={{
            type: "primary",
            loading: loading,
          }}
          cancelButtonProps={{
            type: "primary",
            danger: true,
          }}
        />
      </div>
    </>
  );
};

export default Item;
